import { render, staticRenderFns } from "./phoneVerfication.vue?vue&type=template&id=1a62904a&scoped=true&"
import script from "./phoneVerfication.vue?vue&type=script&lang=js&"
export * from "./phoneVerfication.vue?vue&type=script&lang=js&"
import style0 from "./phoneVerfication.vue?vue&type=style&index=0&id=1a62904a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a62904a",
  null
  
)

export default component.exports